/** Optical scales so Font Awesome and IcoMoon glyphs share one ink size.
 *  Ratio of a reference Font Awesome ink box to each glyph's own box
 *  (max of width and height, over the font em). Values near 1 are omitted.
 *  nav_icon_scale clamps the result so a tab icon stays inside the bar.
 */
const SCALE_MIN = 0.8;
const SCALE_MAX = 1.45;

const FONT_AWESOME_SCALE = {
    "address-card": 0.873,
    "address-card-o": 0.873,
    "adjust": 1.164,
    "adn": 1.164,
    "ambulance": 0.963,
    "american-sign-language-interpreting": 0.778,
    "android": 1.076,
    "angle-double-down": 1.792,
    "angle-double-left": 1.792,
    "angle-double-right": 1.792,
    "angle-double-up": 1.792,
    "angle-down": 1.792,
    "angle-left": 1.792,
    "angle-right": 1.792,
    "angle-up": 1.792,
    "apple": 1.075,
    "archive": 1.075,
    "area-chart": 0.873,
    "arrow-circle-down": 1.164,
    "arrow-circle-left": 1.164,
    "arrow-circle-o-down": 1.164,
    "arrow-circle-o-left": 1.164,
    "arrow-circle-o-right": 1.164,
    "arrow-circle-o-up": 1.164,
    "arrow-circle-right": 1.164,
    "arrow-circle-up": 1.164,
    "arrow-down": 1.148,
    "arrow-left": 1.148,
    "arrow-right": 1.148,
    "arrow-up": 1.148,
    "arrows-alt": 1.164,
    "asl-interpreting": 0.778,
    "asterisk": 1.164,
    "at": 1.164,
    "audio-description": 0.777,
    "automobile": 0.873,
    "backward": 1.16,
    "balance-scale": 0.822,
    "ban": 1.16,
    "bank": 0.931,
    "bar-chart": 0.873,
    "bar-chart-o": 0.873,
    "bars": 1.164,
    "battery": 0.776,
    "battery-0": 0.776,
    "battery-1": 0.776,
    "battery-2": 0.776,
    "battery-3": 0.776,
    "battery-4": 0.776,
    "battery-empty": 0.776,
    "battery-full": 0.776,
    "battery-half": 0.776,
    "battery-quarter": 0.776,
    "battery-three-quarters": 0.776,
    "bed": 0.873,
    "beer": 1.117,
    "behance": 0.873,
    "behance-square": 1.164,
    "bell-slash": 0.885,
    "bell-slash-o": 0.885,
    "bicycle": 0.776,
    "bitbucket": 1.104,
    "bitbucket-square": 1.164,
    "bitcoin": 1.075,
    "black-tie": 1.164,
    "bold": 1.164,
    "bolt": 1.075,
    "book": 1.086,
    "bookmark": 1.182,
    "bookmark-o": 1.182,
    "braille": 0.822,
    "btc": 1.075,
    "bug": 1.117,
    "bullseye": 1.164,
    "buysellads": 1.164,
    "cab": 0.873,
    "camera": 0.931,
    "car": 0.873,
    "caret-down": 1.746,
    "caret-left": 1.746,
    "caret-right": 1.746,
    "caret-square-o-down": 1.164,
    "caret-square-o-left": 1.164,
    "caret-square-o-right": 1.164,
    "caret-square-o-up": 1.164,
    "caret-up": 1.746,
    "cart-arrow-down": 1.075,
    "cart-plus": 1.075,
    "cc": 0.873,
    "cc-amex": 0.776,
    "cc-diners-club": 0.776,
    "cc-discover": 0.776,
    "cc-jcb": 0.776,
    "cc-mastercard": 0.776,
    "cc-paypal": 0.776,
    "cc-stripe": 0.776,
    "cc-visa": 0.776,
    "certificate": 1.166,
    "chain": 1.096,
    "chain-broken": 1.075,
    "check": 1.154,
    "check-circle": 1.164,
    "check-circle-o": 1.164,
    "check-square": 1.164,
    "check-square-o": 1.075,
    "chevron-circle-down": 1.164,
    "chevron-circle-left": 1.164,
    "chevron-circle-right": 1.164,
    "chevron-circle-up": 1.164,
    "chevron-down": 1.109,
    "chevron-left": 1.109,
    "chevron-right": 1.109,
    "chevron-up": 1.109,
    "child": 1.106,
    "circle": 1.164,
    "circle-o": 1.164,
    "circle-o-notch": 1.035,
    "circle-thin": 1.164,
    "clock-o": 1.164,
    "close": 1.505,
    "cloud": 0.931,
    "cloud-download": 0.931,
    "cloud-upload": 0.931,
    "cny": 1.27,
    "code": 0.977,
    "code-fork": 1.164,
    "coffee": 0.963,
    "cog": 1.164,
    "cogs": 0.931,
    "columns": 1.075,
    "compass": 1.164,
    "compress": 1.184,
    "connectdevelop": 0.873,
    "contao": 1.023,
    "copyright": 1.164,
    "credit-card": 0.931,
    "credit-card-alt": 0.776,
    "crop": 1.075,
    "crosshairs": 1.164,
    "cube": 1.075,
    "cubes": 0.822,
    "delicious": 1.164,
    "desktop": 0.931,
    "deviantart": 1.075,
    "diamond": 0.873,
    "digg": 0.873,
    "dot-circle-o": 1.164,
    "download": 1.075,
    "dribbble": 1.164,
    "drivers-license": 0.873,
    "drivers-license-o": 0.873,
    "dropbox": 1.075,
    "eject": 1.164,
    "ellipsis-h": 1.27,
    "ellipsis-v": 1.27,
    "envelope-square": 1.164,
    "eraser": 0.932,
    "eur": 1.27,
    "euro": 1.27,
    "exclamation": 1.27,
    "exclamation-circle": 1.164,
    "expand": 1.164,
    "external-link-square": 1.164,
    "facebook": 1.075,
    "facebook-f": 1.075,
    "facebook-official": 1.164,
    "facebook-square": 1.164,
    "feed": 1.27,
    "fighter-jet": 0.931,
    "film": 0.931,
    "filter": 1.27,
    "fire-extinguisher": 1.096,
    "flag": 1.035,
    "flag-checkered": 1.035,
    "flag-o": 1.035,
    "flash": 1.075,
    "flask": 1.164,
    "flickr": 1.164,
    "floppy-o": 1.164,
    "folder": 1.075,
    "folder-o": 1.075,
    "folder-open": 0.952,
    "folder-open-o": 0.937,
    "font": 1.075,
    "fonticons": 1.164,
    "forumbee": 1.164,
    "forward": 1.16,
    "foursquare": 1.075,
    "free-code-camp": 0.776,
    "frown-o": 1.164,
    "gamepad": 0.931,
    "gavel": 1.033,
    "gbp": 1.27,
    "gear": 1.164,
    "gears": 0.931,
    "genderless": 1.552,
    "get-pocket": 1.04,
    "gg": 0.931,
    "gift": 1.164,
    "git-square": 1.164,
    "github": 1.164,
    "github-alt": 1.075,
    "github-square": 1.164,
    "gittip": 1.164,
    "glass": 1.075,
    "glide": 1.164,
    "globe": 1.164,
    "google": 1.164,
    "google-plus": 0.776,
    "google-plus-circle": 1.164,
    "google-plus-official": 1.164,
    "google-plus-square": 1.164,
    "graduation-cap": 0.776,
    "gratipay": 1.164,
    "group": 0.931,
    "h-square": 1.164,
    "hacker-news": 1.164,
    "hand-grab-o": 1.164,
    "hand-lizard-o": 0.873,
    "hand-rock-o": 1.164,
    "hand-spock-o": 0.931,
    "handshake-o": 0.776,
    "hashtag": 1.036,
    "hdd-o": 1.164,
    "header": 1.072,
    "headphones": 1.075,
    "history": 1.164,
    "home": 1.109,
    "hotel": 0.873,
    "html5": 1.117,
    "id-card": 0.873,
    "id-card-o": 0.873,
    "ils": 1.27,
    "image": 0.931,
    "imdb": 1.164,
    "inbox": 1.164,
    "info": 1.27,
    "info-circle": 1.164,
    "inr": 1.27,
    "instagram": 1.164,
    "institution": 0.931,
    "ioxhost": 0.873,
    "italic": 1.164,
    "joomla": 1.164,
    "jpy": 1.27,
    "jsfiddle": 0.873,
    "key": 1.062,
    "keyboard-o": 0.931,
    "laptop": 0.931,
    "lastfm-square": 1.164,
    "leanpub": 0.873,
    "legal": 1.033,
    "lemon-o": 1.164,
    "level-down": 1.27,
    "level-up": 1.271,
    "lightbulb-o": 1.164,
    "line-chart": 0.873,
    "link": 1.096,
    "linkedin": 1.164,
    "linkedin-square": 1.164,
    "location-arrow": 1.27,
    "lock": 1.27,
    "long-arrow-down": 1.035,
    "long-arrow-left": 1.035,
    "long-arrow-right": 1.035,
    "long-arrow-up": 1.035,
    "magic": 1.092,
    "magnet": 1.164,
    "map-marker": 1.164,
    "map-o": 0.873,
    "mars": 1.164,
    "mars-double": 0.932,
    "mars-stroke": 1.164,
    "mars-stroke-h": 0.933,
    "maxcdn": 1.025,
    "meanpath": 1.164,
    "meetup": 0.97,
    "meh-o": 1.164,
    "microchip": 1.075,
    "microphone": 1.075,
    "microphone-slash": 1.075,
    "minus": 1.27,
    "minus-circle": 1.164,
    "minus-square": 1.164,
    "minus-square-o": 1.27,
    "mixcloud": 0.776,
    "mobile": 1.397,
    "mobile-phone": 1.397,
    "money": 0.931,
    "moon-o": 1.165,
    "mortar-board": 0.776,
    "motorcycle": 0.777,
    "music": 1.075,
    "navicon": 1.164,
    "newspaper-o": 0.873,
    "object-group": 0.873,
    "object-ungroup": 0.776,
    "odnoklassniki-square": 1.164,
    "opencart": 0.776,
    "optin-monster": 0.84,
    "paperclip": 1.17,
    "paragraph": 1.164,
    "pause": 1.164,
    "pause-circle": 1.164,
    "pause-circle-o": 1.164,
    "paw": 1.075,
    "pencil": 1.18,
    "pencil-square": 1.164,
    "percent": 1.164,
    "phone": 1.27,
    "phone-square": 1.164,
    "photo": 0.931,
    "picture-o": 0.931,
    "pie-chart": 1.035,
    "pied-piper": 0.776,
    "pied-piper-alt": 0.914,
    "pied-piper-pp": 1.164,
    "pinterest": 1.164,
    "pinterest-p": 1.075,
    "pinterest-square": 1.164,
    "plane": 1.288,
    "play": 1.158,
    "play-circle": 1.164,
    "play-circle-o": 1.164,
    "plus": 1.27,
    "plus-circle": 1.164,
    "plus-square": 1.164,
    "plus-square-o": 1.27,
    "power-off": 1.075,
    "print": 1.075,
    "puzzle-piece": 1.075,
    "qrcode": 1.27,
    "question": 1.397,
    "question-circle": 1.164,
    "question-circle-o": 1.164,
    "quote-left": 1.075,
    "quote-right": 1.075,
    "ravelry": 0.862,
    "reddit-square": 1.164,
    "refresh": 1.164,
    "remove": 1.505,
    "renren": 1.164,
    "reorder": 1.164,
    "repeat": 1.164,
    "retweet": 0.931,
    "rmb": 1.27,
    "rocket": 1.096,
    "rotate-left": 1.164,
    "rotate-right": 1.164,
    "rouble": 1.27,
    "rss": 1.27,
    "rss-square": 1.164,
    "rub": 1.27,
    "ruble": 1.27,
    "rupee": 1.27,
    "save": 1.164,
    "search": 1.075,
    "search-minus": 1.075,
    "search-plus": 1.075,
    "sellsy": 0.873,
    "share-alt": 1.164,
    "share-alt-square": 1.164,
    "share-square": 1.164,
    "share-square-o": 1.075,
    "shekel": 1.27,
    "sheqel": 1.27,
    "shield": 1.164,
    "ship": 0.89,
    "shirtsinbulk": 1.034,
    "shopping-basket": 0.873,
    "shopping-cart": 1.075,
    "shower": 0.931,
    "sign-in": 1.164,
    "sign-out": 1.14,
    "simplybuilt": 0.873,
    "skyatlas": 0.873,
    "skype": 1.164,
    "slack": 1.075,
    "sliders": 1.164,
    "smile-o": 1.164,
    "snapchat": 1.164,
    "snapchat-ghost": 1.094,
    "snapchat-square": 1.164,
    "sort": 1.27,
    "sort-asc": 1.746,
    "sort-desc": 1.746,
    "sort-down": 1.746,
    "sort-up": 1.746,
    "soundcloud": 0.776,
    "space-shuttle": 0.822,
    "spinner": 1.035,
    "spotify": 1.164,
    "square": 1.164,
    "square-o": 1.27,
    "stack-exchange": 1.164,
    "star": 1.075,
    "star-half": 1.127,
    "star-half-empty": 1.077,
    "star-half-full": 1.077,
    "star-half-o": 1.077,
    "star-o": 1.075,
    "steam-square": 1.164,
    "step-backward": 1.164,
    "step-forward": 1.164,
    "stethoscope": 1.164,
    "sticky-note": 1.164,
    "sticky-note-o": 1.164,
    "stop": 1.164,
    "stop-circle": 1.164,
    "stop-circle-o": 1.164,
    "stumbleupon": 0.931,
    "stumbleupon-circle": 1.164,
    "subscript": 1.168,
    "superscript": 1.169,
    "table": 1.075,
    "tablet": 1.27,
    "tag": 1.18,
    "tags": 0.942,
    "taxi": 0.873,
    "television": 0.931,
    "terminal": 1.083,
    "text-width": 1.076,
    "th-large": 1.075,
    "thumb-tack": 1.075,
    "thumbs-down": 1.117,
    "thumbs-o-down": 1.075,
    "thumbs-o-up": 1.075,
    "thumbs-up": 1.117,
    "ticket": 1.061,
    "times": 1.505,
    "times-circle": 1.164,
    "times-circle-o": 1.164,
    "tint": 1.215,
    "toggle-down": 1.164,
    "toggle-left": 1.164,
    "toggle-off": 0.873,
    "toggle-on": 0.873,
    "toggle-right": 1.164,
    "toggle-up": 1.164,
    "trademark": 0.907,
    "trash": 1.164,
    "trash-o": 1.164,
    "trello": 1.164,
    "tripadvisor": 0.776,
    "trophy": 1.075,
    "truck": 1.035,
    "try": 1.27,
    "tumblr": 1.075,
    "tumblr-square": 1.164,
    "turkish-lira": 1.27,
    "tv": 0.931,
    "twitch": 1.075,
    "twitter": 1.135,
    "twitter-square": 1.164,
    "umbrella": 1.075,
    "underline": 1.164,
    "undo": 1.164,
    "university": 0.931,
    "unlink": 1.075,
    "unlock": 1.075,
    "unlock-alt": 1.164,
    "unsorted": 1.27,
    "upload": 1.075,
    "usb": 0.776,
    "user": 1.164,
    "user-md": 1.164,
    "user-plus": 0.873,
    "user-secret": 1.075,
    "user-times": 0.877,
    "users": 0.931,
    "vcard": 0.873,
    "vcard-o": 0.873,
    "venus-mars": 0.876,
    "viadeo": 1.2,
    "viadeo-square": 1.164,
    "vimeo": 1.099,
    "vimeo-square": 1.164,
    "vine": 1.09,
    "vk": 0.932,
    "volume-down": 1.47,
    "volume-off": 1.47,
    "volume-up": 1.075,
    "wechat": 0.873,
    "weixin": 0.873,
    "whatsapp": 1.155,
    "wifi": 0.91,
    "wikipedia-w": 0.776,
    "window-restore": 0.873,
    "windows": 1.075,
    "wpforms": 1.164,
    "wrench": 1.088,
    "xing": 1.081,
    "xing-square": 1.164,
    "y-combinator": 1.164,
    "y-combinator-square": 1.164,
    "yahoo": 1.075,
    "yc": 1.164,
    "yc-square": 1.164,
    "yen": 1.27,
    "youtube-square": 1.164
};

const ICOMOON_SCALE = {
    "account": 2.354,
    "agenda": 1.703,
    "back": 1.274,
    "cart": 1.844,
    "cinema": 0.808,
    "delivery": 1.04,
    "discounts": 1.972,
    "edit": 4.644,
    "events": 1.851,
    "facebook": 1.906,
    "fidelity": 1.861,
    "history": 1.557,
    "home": 1.969,
    "house": 1.119,
    "info": 2.862,
    "instagram": 1.808,
    "linkedin": 1.792,
    "logout": 1.643,
    "members": 1.417,
    "menu": 1.802,
    "news": 1.805,
    "pass": 1.184,
    "payment": 1.543,
    "phone": 2.815,
    "play": 1.206,
    "pricings": 1.942,
    "profil_1": 1.184,
    "profil_2": 1.184,
    "profil_3": 1.184,
    "profil_4": 1.184,
    "profil_family": 1.156,
    "restaurants": 1.624,
    "seat_booked_by_me": 9.92,
    "seat_busy": 9.92,
    "seat_free": 4.481,
    "services": 1.147,
    "settings": 1.812,
    "ticket": 1.47,
    "wallet": 1.429
};

export const FONT_AWESOME_GLYPHS = [
    "500px",
    "address-book",
    "address-book-o",
    "address-card",
    "address-card-o",
    "adjust",
    "adn",
    "align-center",
    "align-justify",
    "align-left",
    "align-right",
    "amazon",
    "ambulance",
    "american-sign-language-interpreting",
    "anchor",
    "android",
    "angellist",
    "angle-double-down",
    "angle-double-left",
    "angle-double-right",
    "angle-double-up",
    "angle-down",
    "angle-left",
    "angle-right",
    "angle-up",
    "apple",
    "archive",
    "area-chart",
    "arrow-circle-down",
    "arrow-circle-left",
    "arrow-circle-o-down",
    "arrow-circle-o-left",
    "arrow-circle-o-right",
    "arrow-circle-o-up",
    "arrow-circle-right",
    "arrow-circle-up",
    "arrow-down",
    "arrow-left",
    "arrow-right",
    "arrow-up",
    "arrows",
    "arrows-alt",
    "arrows-h",
    "arrows-v",
    "asl-interpreting",
    "assistive-listening-systems",
    "asterisk",
    "at",
    "audio-description",
    "automobile",
    "backward",
    "balance-scale",
    "ban",
    "bandcamp",
    "bank",
    "bar-chart",
    "bar-chart-o",
    "barcode",
    "bars",
    "bath",
    "bathtub",
    "battery",
    "battery-0",
    "battery-1",
    "battery-2",
    "battery-3",
    "battery-4",
    "battery-empty",
    "battery-full",
    "battery-half",
    "battery-quarter",
    "battery-three-quarters",
    "bed",
    "beer",
    "behance",
    "behance-square",
    "bell",
    "bell-o",
    "bell-slash",
    "bell-slash-o",
    "bicycle",
    "binoculars",
    "birthday-cake",
    "bitbucket",
    "bitbucket-square",
    "bitcoin",
    "black-tie",
    "blind",
    "bluetooth",
    "bluetooth-b",
    "bold",
    "bolt",
    "bomb",
    "book",
    "bookmark",
    "bookmark-o",
    "braille",
    "briefcase",
    "btc",
    "bug",
    "building",
    "building-o",
    "bullhorn",
    "bullseye",
    "bus",
    "buysellads",
    "cab",
    "calculator",
    "calendar",
    "calendar-check-o",
    "calendar-minus-o",
    "calendar-o",
    "calendar-plus-o",
    "calendar-times-o",
    "camera",
    "camera-retro",
    "car",
    "caret-down",
    "caret-left",
    "caret-right",
    "caret-square-o-down",
    "caret-square-o-left",
    "caret-square-o-right",
    "caret-square-o-up",
    "caret-up",
    "cart-arrow-down",
    "cart-plus",
    "cc",
    "cc-amex",
    "cc-diners-club",
    "cc-discover",
    "cc-jcb",
    "cc-mastercard",
    "cc-paypal",
    "cc-stripe",
    "cc-visa",
    "certificate",
    "chain",
    "chain-broken",
    "check",
    "check-circle",
    "check-circle-o",
    "check-square",
    "check-square-o",
    "chevron-circle-down",
    "chevron-circle-left",
    "chevron-circle-right",
    "chevron-circle-up",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevron-up",
    "child",
    "chrome",
    "circle",
    "circle-o",
    "circle-o-notch",
    "circle-thin",
    "clipboard",
    "clock-o",
    "clone",
    "close",
    "cloud",
    "cloud-download",
    "cloud-upload",
    "cny",
    "code",
    "code-fork",
    "codepen",
    "codiepie",
    "coffee",
    "cog",
    "cogs",
    "columns",
    "comment",
    "comment-o",
    "commenting",
    "commenting-o",
    "comments",
    "comments-o",
    "compass",
    "compress",
    "connectdevelop",
    "contao",
    "copy",
    "copyright",
    "creative-commons",
    "credit-card",
    "credit-card-alt",
    "crop",
    "crosshairs",
    "css3",
    "cube",
    "cubes",
    "cut",
    "cutlery",
    "dashboard",
    "dashcube",
    "database",
    "deaf",
    "deafness",
    "dedent",
    "delicious",
    "desktop",
    "deviantart",
    "diamond",
    "digg",
    "dollar",
    "dot-circle-o",
    "download",
    "dribbble",
    "drivers-license",
    "drivers-license-o",
    "dropbox",
    "drupal",
    "edge",
    "edit",
    "eercast",
    "eject",
    "ellipsis-h",
    "ellipsis-v",
    "empire",
    "envelope",
    "envelope-o",
    "envelope-open",
    "envelope-open-o",
    "envelope-square",
    "envira",
    "eraser",
    "etsy",
    "eur",
    "euro",
    "exchange",
    "exclamation",
    "exclamation-circle",
    "exclamation-triangle",
    "expand",
    "expeditedssl",
    "external-link",
    "external-link-square",
    "eye",
    "eye-slash",
    "eyedropper",
    "fa",
    "facebook",
    "facebook-f",
    "facebook-official",
    "facebook-square",
    "fast-backward",
    "fast-forward",
    "fax",
    "feed",
    "female",
    "fighter-jet",
    "file",
    "file-archive-o",
    "file-audio-o",
    "file-code-o",
    "file-excel-o",
    "file-image-o",
    "file-movie-o",
    "file-o",
    "file-pdf-o",
    "file-photo-o",
    "file-picture-o",
    "file-powerpoint-o",
    "file-sound-o",
    "file-text",
    "file-text-o",
    "file-video-o",
    "file-word-o",
    "file-zip-o",
    "files-o",
    "film",
    "filter",
    "fire",
    "fire-extinguisher",
    "firefox",
    "first-order",
    "flag",
    "flag-checkered",
    "flag-o",
    "flash",
    "flask",
    "flickr",
    "floppy-o",
    "folder",
    "folder-o",
    "folder-open",
    "folder-open-o",
    "font",
    "font-awesome",
    "fonticons",
    "fort-awesome",
    "forumbee",
    "forward",
    "foursquare",
    "free-code-camp",
    "frown-o",
    "futbol-o",
    "gamepad",
    "gavel",
    "gbp",
    "ge",
    "gear",
    "gears",
    "genderless",
    "get-pocket",
    "gg",
    "gg-circle",
    "gift",
    "git",
    "git-square",
    "github",
    "github-alt",
    "github-square",
    "gitlab",
    "gittip",
    "glass",
    "glide",
    "glide-g",
    "globe",
    "google",
    "google-plus",
    "google-plus-circle",
    "google-plus-official",
    "google-plus-square",
    "google-wallet",
    "graduation-cap",
    "gratipay",
    "grav",
    "group",
    "h-square",
    "hacker-news",
    "hand-grab-o",
    "hand-lizard-o",
    "hand-o-down",
    "hand-o-left",
    "hand-o-right",
    "hand-o-up",
    "hand-paper-o",
    "hand-peace-o",
    "hand-pointer-o",
    "hand-rock-o",
    "hand-scissors-o",
    "hand-spock-o",
    "hand-stop-o",
    "handshake-o",
    "hard-of-hearing",
    "hashtag",
    "hdd-o",
    "header",
    "headphones",
    "heart",
    "heart-o",
    "heartbeat",
    "history",
    "home",
    "hospital-o",
    "hotel",
    "hourglass",
    "hourglass-1",
    "hourglass-2",
    "hourglass-3",
    "hourglass-end",
    "hourglass-half",
    "hourglass-o",
    "hourglass-start",
    "houzz",
    "html5",
    "i-cursor",
    "id-badge",
    "id-card",
    "id-card-o",
    "ils",
    "image",
    "imdb",
    "inbox",
    "indent",
    "industry",
    "info",
    "info-circle",
    "inr",
    "instagram",
    "institution",
    "internet-explorer",
    "intersex",
    "ioxhost",
    "italic",
    "joomla",
    "jpy",
    "jsfiddle",
    "key",
    "keyboard-o",
    "krw",
    "language",
    "laptop",
    "lastfm",
    "lastfm-square",
    "leaf",
    "leanpub",
    "legal",
    "lemon-o",
    "level-down",
    "level-up",
    "life-bouy",
    "life-buoy",
    "life-ring",
    "life-saver",
    "lightbulb-o",
    "line-chart",
    "link",
    "linkedin",
    "linkedin-square",
    "linode",
    "linux",
    "list",
    "list-alt",
    "list-ol",
    "list-ul",
    "location-arrow",
    "lock",
    "long-arrow-down",
    "long-arrow-left",
    "long-arrow-right",
    "long-arrow-up",
    "low-vision",
    "magic",
    "magnet",
    "mail-forward",
    "mail-reply",
    "mail-reply-all",
    "male",
    "map",
    "map-marker",
    "map-o",
    "map-pin",
    "map-signs",
    "mars",
    "mars-double",
    "mars-stroke",
    "mars-stroke-h",
    "mars-stroke-v",
    "maxcdn",
    "meanpath",
    "medium",
    "medkit",
    "meetup",
    "meh-o",
    "mercury",
    "microchip",
    "microphone",
    "microphone-slash",
    "minus",
    "minus-circle",
    "minus-square",
    "minus-square-o",
    "mixcloud",
    "mobile",
    "mobile-phone",
    "modx",
    "money",
    "moon-o",
    "mortar-board",
    "motorcycle",
    "mouse-pointer",
    "music",
    "navicon",
    "neuter",
    "newspaper-o",
    "object-group",
    "object-ungroup",
    "odnoklassniki",
    "odnoklassniki-square",
    "opencart",
    "openid",
    "opera",
    "optin-monster",
    "outdent",
    "pagelines",
    "paint-brush",
    "paper-plane",
    "paper-plane-o",
    "paperclip",
    "paragraph",
    "paste",
    "pause",
    "pause-circle",
    "pause-circle-o",
    "paw",
    "paypal",
    "pencil",
    "pencil-square",
    "pencil-square-o",
    "percent",
    "phone",
    "phone-square",
    "photo",
    "picture-o",
    "pie-chart",
    "pied-piper",
    "pied-piper-alt",
    "pied-piper-pp",
    "pinterest",
    "pinterest-p",
    "pinterest-square",
    "plane",
    "play",
    "play-circle",
    "play-circle-o",
    "plug",
    "plus",
    "plus-circle",
    "plus-square",
    "plus-square-o",
    "podcast",
    "power-off",
    "print",
    "product-hunt",
    "puzzle-piece",
    "qq",
    "qrcode",
    "question",
    "question-circle",
    "question-circle-o",
    "quora",
    "quote-left",
    "quote-right",
    "ra",
    "random",
    "ravelry",
    "rebel",
    "recycle",
    "reddit",
    "reddit-alien",
    "reddit-square",
    "refresh",
    "registered",
    "remove",
    "renren",
    "reorder",
    "repeat",
    "reply",
    "reply-all",
    "resistance",
    "retweet",
    "rmb",
    "road",
    "rocket",
    "rotate-left",
    "rotate-right",
    "rouble",
    "rss",
    "rss-square",
    "rub",
    "ruble",
    "rupee",
    "s15",
    "safari",
    "save",
    "scissors",
    "scribd",
    "search",
    "search-minus",
    "search-plus",
    "sellsy",
    "send",
    "send-o",
    "server",
    "share",
    "share-alt",
    "share-alt-square",
    "share-square",
    "share-square-o",
    "shekel",
    "sheqel",
    "shield",
    "ship",
    "shirtsinbulk",
    "shopping-bag",
    "shopping-basket",
    "shopping-cart",
    "shower",
    "sign-in",
    "sign-language",
    "sign-out",
    "signal",
    "signing",
    "simplybuilt",
    "sitemap",
    "skyatlas",
    "skype",
    "slack",
    "sliders",
    "slideshare",
    "smile-o",
    "snapchat",
    "snapchat-ghost",
    "snapchat-square",
    "snowflake-o",
    "soccer-ball-o",
    "sort",
    "sort-alpha-asc",
    "sort-alpha-desc",
    "sort-amount-asc",
    "sort-amount-desc",
    "sort-asc",
    "sort-desc",
    "sort-down",
    "sort-numeric-asc",
    "sort-numeric-desc",
    "sort-up",
    "soundcloud",
    "space-shuttle",
    "spinner",
    "spoon",
    "spotify",
    "square",
    "square-o",
    "stack-exchange",
    "stack-overflow",
    "star",
    "star-half",
    "star-half-empty",
    "star-half-full",
    "star-half-o",
    "star-o",
    "steam",
    "steam-square",
    "step-backward",
    "step-forward",
    "stethoscope",
    "sticky-note",
    "sticky-note-o",
    "stop",
    "stop-circle",
    "stop-circle-o",
    "street-view",
    "strikethrough",
    "stumbleupon",
    "stumbleupon-circle",
    "subscript",
    "subway",
    "suitcase",
    "sun-o",
    "superpowers",
    "superscript",
    "support",
    "table",
    "tablet",
    "tachometer",
    "tag",
    "tags",
    "tasks",
    "taxi",
    "telegram",
    "television",
    "tencent-weibo",
    "terminal",
    "text-height",
    "text-width",
    "th",
    "th-large",
    "th-list",
    "themeisle",
    "thermometer",
    "thermometer-0",
    "thermometer-1",
    "thermometer-2",
    "thermometer-3",
    "thermometer-4",
    "thermometer-empty",
    "thermometer-full",
    "thermometer-half",
    "thermometer-quarter",
    "thermometer-three-quarters",
    "thumb-tack",
    "thumbs-down",
    "thumbs-o-down",
    "thumbs-o-up",
    "thumbs-up",
    "ticket",
    "times",
    "times-circle",
    "times-circle-o",
    "times-rectangle",
    "times-rectangle-o",
    "tint",
    "toggle-down",
    "toggle-left",
    "toggle-off",
    "toggle-on",
    "toggle-right",
    "toggle-up",
    "trademark",
    "train",
    "transgender",
    "transgender-alt",
    "trash",
    "trash-o",
    "tree",
    "trello",
    "tripadvisor",
    "trophy",
    "truck",
    "try",
    "tty",
    "tumblr",
    "tumblr-square",
    "turkish-lira",
    "tv",
    "twitch",
    "twitter",
    "twitter-square",
    "umbrella",
    "underline",
    "undo",
    "universal-access",
    "university",
    "unlink",
    "unlock",
    "unlock-alt",
    "unsorted",
    "upload",
    "usb",
    "usd",
    "user",
    "user-circle",
    "user-circle-o",
    "user-md",
    "user-o",
    "user-plus",
    "user-secret",
    "user-times",
    "users",
    "vcard",
    "vcard-o",
    "venus",
    "venus-double",
    "venus-mars",
    "viacoin",
    "viadeo",
    "viadeo-square",
    "video-camera",
    "vimeo",
    "vimeo-square",
    "vine",
    "vk",
    "volume-control-phone",
    "volume-down",
    "volume-off",
    "volume-up",
    "warning",
    "wechat",
    "weibo",
    "weixin",
    "whatsapp",
    "wheelchair",
    "wheelchair-alt",
    "wifi",
    "wikipedia-w",
    "window-close",
    "window-close-o",
    "window-maximize",
    "window-minimize",
    "window-restore",
    "windows",
    "won",
    "wordpress",
    "wpbeginner",
    "wpexplorer",
    "wpforms",
    "wrench",
    "xing",
    "xing-square",
    "y-combinator",
    "y-combinator-square",
    "yahoo",
    "yc",
    "yc-square",
    "yelp",
    "yen",
    "yoast",
    "youtube",
    "youtube-play",
    "youtube-square"
];

export const ICOMOON_GLYPHS = [
    "account",
    "agenda",
    "back",
    "cart",
    "cinema",
    "delivery",
    "discounts",
    "edit",
    "events",
    "facebook",
    "fidelity",
    "history",
    "home",
    "house",
    "info",
    "instagram",
    "linkedin",
    "logout",
    "members",
    "menu",
    "news",
    "pass",
    "payment",
    "phone",
    "play",
    "pricings",
    "profil_1",
    "profil_2",
    "profil_3",
    "profil_4",
    "profil_family",
    "restaurants",
    "seat_booked_by_me",
    "seat_busy",
    "seat_free",
    "services",
    "settings",
    "ticket",
    "wallet"
];

export function nav_icon_font(type) {
    if (type === 'icomoon' || type === 'explorit')
        return 'icomoon';
    if (type === 'font-awesome')
        return 'font-awesome';
    return null;
}

export function nav_icon_scale(type, name) {
    const font = nav_icon_font(type);
    const key = String(name || '').trim();
    if (!font || !key)
        return 1;
    const table = font === 'icomoon' ? ICOMOON_SCALE : FONT_AWESOME_SCALE;
    const raw = table[key] ?? table[key.toLowerCase()];
    if (raw == null)
        return 1;
    return Math.min(SCALE_MAX, Math.max(SCALE_MIN, raw));
}
